import { render, staticRenderFns } from "./cenMessage.vue?vue&type=template&id=3732dfa4&scoped=true&"
import script from "./cenMessage.vue?vue&type=script&lang=js&"
export * from "./cenMessage.vue?vue&type=script&lang=js&"
import style0 from "./cenMessage.vue?vue&type=style&index=0&id=3732dfa4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3732dfa4",
  null
  
)

export default component.exports